export const products = [
  {
    id: 1,
    img: "https://i.ibb.co/Qf7X689/Mayra.png",
    link: "https://mayra-1.herokuapp.com/",
  },
  {
    id: 2,
    img: "https://i.ibb.co/xCT5z4z/Dine-Fine.png",
    link: "https://dine-fine-163d7.web.app/",
  },
];
